import { Component, ErrorHandler, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AccessService } from 'src/app/core/services/access.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.css'],
})
export class RedirectComponent implements OnInit {
  constructor(private router: Router, private auth: AccessService) {}

  ngOnInit() {
    const isAdmin = this.auth.isInGroup('user', 'admin');
    if (isAdmin) {
      this.router.navigate(['/reports/kpi-overview']);
    } else {
      this.router.navigate(['/audience/dashboard']);
    }
  }
}
